module.exports = __webpack_public_path__ + "static/media/refinery.f03377e9.jpg";